import React, { useState } from 'react';
import { Buffer } from 'buffer';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

import DynamicForm from '../../dynamicForm/DynamicForm';
import { ActionIconItem } from '../../others/ActionIconItem';

import { useDataAuth } from '../../../hooks/useDataAuth';
import { useNotification } from '../../../hooks/useNotification';
import { useValidateDynamicForm } from '../../../hooks/useValidateDynamicForm';
import { ActionButtons } from '../../others/ActionButtons';
import { useForm } from '../../../hooks/useForm';
import { useApiResolver } from '../../../hooks/useApiResolver';

import { isNotEmptyObject } from '../../../utils/jsonValidator';
import { ensureArray } from '../../../utils/validateResponseApi';


export const ModalForms = ({ data, id_user_action, parent, handleChange, DocManager, requires_check }) => {
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const { resolveValue } = useApiResolver();
    const { rowsChecked, handleRowsChecked } = DocManager;
    const [open, setOpen] = useState(false);
    const [errorInputs, validForm, resetErrors] = useValidateDynamicForm();
    const [valuesForm, handleInputChange, handleDirectInputChange, , reset] = useForm({ id_user_action });

    const vbles = {
        id_parent: parent?.id || null,
        id_company: DocManager?.id_company || null,
        select_company: DocManager?.select_company || false,
    };

    const setFileTemp = (bytes, field) => {
        const u8 = new Uint8Array(bytes);
        var b64 = Buffer.from(u8).toString('base64');
        handleDirectInputChange(field + '_file_B64', b64);
    }

    const handleFileChange = (event, field) => {
        handleDirectInputChange(field, event.target.files[0].name);
        const asfile = event.target.files[0];
        if (asfile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const arrayBuffer = e.target.result;
                const bytes = new Uint8Array(arrayBuffer);
                setFileTemp(bytes, field);
            };
            reader.readAsArrayBuffer(asfile);
        }
        event.target.value = '';
    };

    const setValuesSelectGeneric = (e) => {
        const { name, value, fullObject } = e.target;
        handleDirectInputChange(name, value);
        if (isNotEmptyObject(fullObject))
            ensureArray(data?.form).forEach((element) => {
                if (fullObject.hasOwnProperty(element.id)) {
                    handleDirectInputChange(`${name}_${element.id}`, fullObject[element.id]);
                    handleDirectInputChange(element.id, fullObject[element.id]);
                }
            })
    }

    const CallApi = async (param) => {
        if (!validForm(data.form, valuesForm)) {
            return false;
        }
        handleOpenModal(false);
        const trigger = param.trigger;
        const url = trigger[0]?.url;
        const method = trigger[0]?.method;
        let bodyData = trigger[0]?.bodyData;
        const filters = {};
        if (parent) {
            const prnt = { ...parent };
            delete prnt.propiedad;
            filters.id_unique = {
                "value": prnt.id_unique,
                "operator": "=",
                "type": "string"
            }
            if (DocManager?.rowsCheckedDetails.length > 0)
                filters.id = {
                    "value": DocManager?.rowsCheckedDetails.join(","),
                    "operator": "IN",
                    "type": "string"
                }
        } else {
            filters.id_unique = {
                "value": DocManager?.rowsChecked.join(","),
                "operator": "IN",
                "type": "string"
            }
        }
        const filt = JSON.stringify(filters);

        if (requires_check === 'true') {
            if (rowsChecked?.length > 0 || DocManager?.rowsCheckedDetails.length > 0)
                bodyData.variables = filt;
            else {
                sendNotification({ msg: 'Debes selecionar por lo menos una fila', variant: 'error' });
                return false;
            }
        }
        else {
            if (DocManager?.rowsChecked.length > 0 || DocManager?.rowsCheckedDetails.length > 0)
                bodyData.variables = filt;
            else {
                const fil = DocManager?.filters;
                if (parent) {
                    const prnt = { ...parent };
                    delete prnt.propiedad;
                    fil.id_unique = {
                        "value": prnt.id_unique,
                        "operator": "=",
                        "type": "string"
                    }
                }
                bodyData.variables = JSON.stringify({ filters: fil });
            }
        }

        if (parent) {
            const prnt = { ...parent };
            delete prnt.propiedad;
            bodyData.parent = prnt;
        }

        let str = JSON.stringify(bodyData);
        for (let key in valuesForm) {
            let value = valuesForm[key];
            value = String(value || '').replace(/"/g, '\\"').replace(/[\r\n]+/g, ' ');
            if (value === `{${key}}`)
                value = ''
            str = str.toString().replace(`{${key}}`, value).replace(`{[form].${key}}`, value);
        }
        let config = {
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userSession.token}`
            },
            data: str
        };
        handleRowsChecked([]);

        console.log("Llamado desde aca! ", config);
        try {
            const response = await resolveValue(config, param?.response_type !== 'download');
            if (response.status === 200) {
                if (param?.response_type === 'download') {
                    console.log("response ", response);
                    let ext = param.name_file.split('.').pop();
                    const byteCharacters = atob(response.data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: `application/${ext}` });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', param.name_file.replace('{date}', moment().format('YYYY-MM-DDTHH:mm:ssZ')));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                setTimeout(() => {
                    handleChange();
                }, 500);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleOpenModal = (isOpen) => {
        setOpen(isOpen);
        resetErrors();
        reset();
    }

    return (
        <React.Fragment>
            <ActionIconItem
                item={data}
                onClick={() => handleOpenModal(true)}
            />

            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        width: data?.width ? `${data.width}%` : '35%',
                        maxHeight: '90vh',
                        borderRadius: 2,
                    },
                }}
            >
                <DialogTitle sx={{ borderBottom: '1px solid #ccc' }}>
                    <Typography id="form-modal-title" variant="h6" component="h2">
                        {data.accion}
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ overflowY: 'auto', flexGrow: 1 }}>
                    <DynamicForm
                        values={valuesForm}
                        scheme={data.form}
                        errorInputs={errorInputs}
                        onChange={handleInputChange}
                        handleFileChange={handleFileChange}
                        setChanges={handleDirectInputChange}
                        setValuesSelectGeneric={setValuesSelectGeneric}
                        variables={vbles}
                    />
                </DialogContent>

                <DialogActions sx={{ borderTop: '1px solid #ccc' }}>
                    <ActionButtons
                        onSubmit={() => CallApi(data)}
                        onCancel={() => handleOpenModal(false)}
                    />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}